import React from 'react'
import abImg from '../../images/3.jpg'
import SectionTitle from '../SectionTitle/SectionTitle';
import About from '../about/about_bottom'
import AboutSection from '../UiStyle/AboutSection.css'


const AboutHistory = (props) => {

    return (
      <div className="about-history-section pb-0">
        <div className="container">
          <div className="history-top">
            <div className="row">
              <div className="col-lg-12 what-we-offer">
                <SectionTitle sTitle={"What We Offer"} />
              </div>
            </div> 
          </div>
          <div className="history-wrap">
            <div className="row">
              <div className="col-lg-7">
                <div className="history-items">
                  <div className="history-item">
                    <h3>
                      <i className="icon-medicine"></i>High-Quality Generic
                      Medicines
                    </h3>
                    <p>
                    Trusted alternatives that share the same active ingredients and effectiveness as their branded counterparts.
                    </p>
                  </div>
                  <div className="history-item">
                    <h3>
                      <i className="icon-cart" style={{ marginRight: 10 }}></i>Wide Range of Categories
                    </h3>
                    <p>
                    Our online pharmacy offers a comprehensive selection of medications, covering everything from chronic conditions and general wellness to specialized treatments and healthcare needs.
                    </p>
                  </div>
                  <div className="history-item">
                    <h3>
                      <i className="icon-medical"></i>Prescription & OTC
                      Products
                    </h3>
                    <p>
                    Over-the-counter medications require no prescription. Email us or upload your prescription at checkout. 
                    </p>
                  </div>
                  <div className="history-item">
                    <h3>
                      <i className="icon-location"></i>Nationwide Delivery in
                      the USA, Australia, and the UK
                    </h3>
                    <p>
                    We offer home delivery within 20–30 days, bringing essential treatments directly to your door.
                    </p>
                  </div>
                  <div className="history-item">
                    <h3>
                      <i className="icon-shipped"></i>Secure Ordering
                    </h3>
                    <p>
                    We accept credit cards, debit cards, and e-checks, all processed through trusted, encrypted gateways.
                    </p>
                  </div>
                  <div className="history-item">
                    <h3>
                      <i className="icon-product"></i>Affordable Pricing & Bulk
                      Discounts
                    </h3>
                    <p>
                    We offer savings on bulk purchases and send reminders for repeat orders.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="about-img-wrap">
                  <div className="about-img-top">
                    <img src={abImg} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <About />
          </div>
        </div>
      </div>
    );
}

export default AboutHistory;